import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  body {
    font-family: Lato, "Lucida Grande", Tahoma, Sans-Serif;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
  }
`